import styled from "styled-components";

export const Loader = styled.div`
  width: 100%;
  height: calc(100vh - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RootContainer = styled.div`
  padding: 24px 0;
`;

export const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img.attrs({
  alt: "icon",
})`
  width: 74px;
  height: 74px;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 12px;
`;

export const Title = styled.div`
  padding-top: 16px;
  padding-bottom: 24px;
  text-align: center;
  color: #13100f;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const PlayerListContainer = styled.div`
  width: 100%;
  margin: 0 0 0 0;
  overflow: auto;
  background: #fff;
  border-radius: 16px 16px 0px 0px;
`;

export const PlayerBox = styled.div`
  border-bottom: 1px solid #F2F1F0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0.5;
`;

export const NoCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0.3;
  padding: 18px 8px;
`;

export const Divider = styled.div`
  width: 1px;
  height: 72px;
  border-right: 1px solid #F2F1F0;
`;

export const NoText = styled.div`
  color: #342309;
  font-weight: 600;
  font-size: 12px;
`;

export const NameCard = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  flex: 1.7;
  padding: 18px 8px;
`;

export const AmountCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1;
  padding: 8px 8px 18px 8px;
`;

export const NameText = styled.div`
  color: #13100F;
  font-size: 15px;
  font-weight: 600;
`;

export const PhoneText = styled.div`
  color: #8E969F;
  font-size: 11px;
  font-weight: 400;
`;

export const AmountText = styled.div`
  color: #13100F;
  font-size: 14px;
  font-weight: 600;
`;
